document.addEventListener('DOMContentLoaded', function() {
  document.addEventListener('rebuy:smartcart.hide', (event) => {
    const smartCart = event.detail.smartcart;

    console.log('rebuy:smartcart.hide: smartcart', smartCart);

    document.body.classList.remove('slideout-right--open');
    document.body.style.overflow = 'auto';
    document.body.style.position = 'static';
  });
});

(function() {
  function variantOf(product) {
    return product.selected_variant || (product.variants && product.variants[0]) || {};
  }

  function salePrices(product) {
    var v = variantOf(product);
    var price = parseFloat(product.price != null ? product.price : v.price);
    var compare = parseFloat(product.compare_at_price != null ? product.compare_at_price : v.compare_at_price);
    return { price: price, compare: compare };
  }

  function isOnSale(product) {
    var p = salePrices(product);
    return !isNaN(p.price) && !isNaN(p.compare) && p.compare > p.price;
  }

  function isAvailable(product) {
    var v = variantOf(product);
    if (typeof product.available === 'boolean') return product.available;
    if (typeof v.available === 'boolean') return v.available;
    return true;
  }

  function normalizeTags(product) {
    if (Array.isArray(product.tags)) return product.tags;
    return (product.tags || '').split(',').map(function(t) { return t.trim(); }).filter(Boolean);
  }

  function isNew(product) {
    var mf = product.metafields;
    if (!mf) return false;
    var value = mf['custom.badge_new'];
    return value === true || value === 'true' || value === 1 || value === '1';
  }

  function makeBadge(className, text) {
    var el = document.createElement('div');
    el.className = className;
    el.textContent = text;
    return el;
  }

  function saleLabel(product, cfg) {
    if (cfg.saleItems === 'percentage') {
      var p = salePrices(product);
      var percent = Math.round((p.compare - p.price) / p.compare * 100);
      return (cfg.strings.savings || '%% OFF').replace('%%', percent + '%');
    }
    return cfg.strings.sale;
  }

  function injectBadges(card, product) {
    var cfg = window.RebuyTags;
    Array.prototype.forEach.call(card.querySelectorAll('.product-tags-bar'), function(node) {
      node.parentNode.removeChild(node);
    });

    var iconStyle = cfg.iconStyle || 'circle_icon';
    var isCircle = iconStyle === 'circle_icon';
    var available = isAvailable(product);
    var onSale = isOnSale(product);
    var preorder = product.template_suffix === 'pre-order';
    var newBadge = isNew(product);
    var tags = normalizeTags(product);

    var left = document.createElement('div');
    left.className = 'product-tags product-tags--left';
    var right = document.createElement('div');
    right.className = 'product-tags product-tags--right';

    if (available) {
      if (onSale) left.appendChild(makeBadge('sale-item icn ' + iconStyle, saleLabel(product, cfg)));
    } else if (!isCircle) {
      left.appendChild(makeBadge('so icn ' + iconStyle, cfg.strings.sold));
    }

    if (available && newBadge) right.appendChild(makeBadge('new icn ' + iconStyle, cfg.strings.new));
    if (available && preorder) right.appendChild(makeBadge('pre-order icn ' + iconStyle, cfg.strings.preorder));
    if (!available && isCircle) right.appendChild(makeBadge('so icn ' + iconStyle, cfg.strings.sold));

    tags.forEach(function(tag) {
      if (tag.indexOf('tag_sale_') === 0) {
        left.appendChild(makeBadge('icn product-tag product-tag--sale', tag.slice(9)));
      } else if (tag.indexOf('tag_') === 0) {
        right.appendChild(makeBadge('icn product-tag product-tag--default', tag.slice(4)));
      }
    });

    if (!left.children.length && !right.children.length) return;

    var bar = document.createElement('div');
    bar.className = 'product-tags-bar';
    if (left.children.length) bar.appendChild(left);
    if (right.children.length) bar.appendChild(right);

    var media = card.querySelector('.rebuy-product-media') || card.querySelector('.rebuy-product-image') || card;
    media.appendChild(bar);
  }

  function productIdOf(card) {
    var match = (card.className || '').match(/product-id-(\d+)/);
    return match ? match[1] : null;
  }

  function decorateWidget(widget) {
    if (!window.RebuyTags || !widget) return;
    var container = document.getElementById('rebuy-widget-' + widget.id);
    if (!container) return;
    if (container.classList.contains('widget-type-dynamic-bundle') || container.classList.contains('widget-type-cart')) return;
    var products = (widget.data && widget.data.products) || [];
    if (!products.length) return;
    var byId = {};
    products.forEach(function(p) { byId[String(p.id)] = p; });

    Array.prototype.forEach.call(container.querySelectorAll('.rebuy-product-block'), function(card) {
      var pid = productIdOf(card);
      if (!pid || !byId[pid]) return;
      if (card.getAttribute('data-rebuy-tagged') === pid) return;
      injectBadges(card, byId[pid]);
      card.setAttribute('data-rebuy-tagged', pid);
    });
  }

  function decorateAll() {
    if (!window.Rebuy || !window.Rebuy.widgets) return;
    window.Rebuy.widgets.forEach(decorateWidget);
  }

  var scheduled;
  function scheduleDecorate() {
    clearTimeout(scheduled);
    scheduled = setTimeout(decorateAll, 150);
  }

  ['rebuy.ready', 'rebuy.productsChange', 'rebuy:ready', 'rebuy:productsChange'].forEach(function(name) {
    document.addEventListener(name, scheduleDecorate);
  });

  function startObserver() {
    if (!document.body || typeof MutationObserver === 'undefined') return;
    new MutationObserver(function(mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].addedNodes && mutations[i].addedNodes.length) {
          scheduleDecorate();
          return;
        }
      }
    }).observe(document.body, { childList: true, subtree: true });
  }

  function init() {
    decorateAll();
    startObserver();
    [500, 1500, 3000].forEach(function(delay) { setTimeout(decorateAll, delay); });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
